// @ts-nocheck
/* eslint-disable */
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Alert, Button, Input, Modal, Radio, Spin, Switch, message } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { T, TF } from 'react-translator-component';
import { usersListFilter } from '../../../utils/list';
import {
  formatCpfOrCnpj,
  isCnpjInput,
  isValidCnpj,
  stripCnpj,
} from '../../../utils/cnpj/cnpj';

// styles and mocks
import { combiningObjects } from './listFormater';
import StationCardInnerContent from './StationCardInnerContent/StationCardInnerContent';
import * as S from './styled';

import { getChargePointGroups } from '../../../hooks/chargepointGroups';
import { checkChargePoint, getChargePoints } from '../../../hooks/chargepoints';
import {
  getReportQuota,
  createUnifiedReport,
  createSeparatedReport,
  createXlsxChargerReport,
} from '../../../hooks/reports';
import { getUserDashTransactionPermission } from '../../../hooks/users';
import { getTenants } from '../../../hooks/tenants';
import { ChargePoint } from '../../../types/responses/ChargePoints';
import {
  normalOrder,
  orderByCity,
  orderByUF,
  orderByHearbeat,
} from '../../../utils/columnHeaderOrder';
import { setIconActive } from '../../../utils/list';
import {
  parserStationGroupsForSelect,
  parserTenantsForSelect,
  parserStatusForSelect,
} from '../../../utils/stations/stationSelect';
import {
  stationsListTagFilter,
  stationFilter,
  stationStatusFilter,
} from '../../../utils/stations/stationsListFilter';
import { COLORS } from '../../../utils/theme/colors';
import { statusFilterOptions } from '../../../constants/chargepoints-status-filter';
// components
import ChargerIcon from '../../atoms/icons/ChargerIcon';
import RangePickerCustom from '../../atoms/LegacyRangePickerCustom';
import { HeaderIcon } from '../../molecules/HeaderIcon/HeaderIcon';
import { HeaderIcon2 } from '../../molecules/HeaderIcon2/HeaderIcon2';
import { ListSkeleton } from '../../molecules/ListSkeleton/ListSkeleton';
import { Search } from '../../molecules/Search';
import { Select } from '../../organisms/Select';
import CardListConstructor from '../CardListConstructor/CardListConstructor';
// functions
import { closeAllCards } from '../CardListConstructor/helpers';
import EmptySearch from '../EmptySearch';
import { modalErrorReport } from '../../../utils/modalErrorReport/modalErrorReport';
import { getProName } from '../../../utils/getProName/getProName';

const START = moment().subtract(20, 'days').format('DD/MM/YYYY');
const END = moment().format('DD/MM/YYYY');

const antLoadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const ChartIconSVG = () => (
  <svg
    width='32px'
    height='32px'
    viewBox='0 0 24 24'
    fill='currentColor'
    style={{ marginRight: '12px' }}
  >
    <rect x='1' y='18' width='4' height='3' fill='#1890ff' rx='1.5' />

    <rect x='6' y='6' width='4.5' height='15' fill='#52c41a' rx='2' />

    <rect x='12' y='8' width='4.5' height='13' fill='#13c2c2' rx='2' />

    <rect x='18' y='0' width='4.5' height='21' fill='#193add' rx='2' />
  </svg>
);

const THEME = localStorage.getItem('theme');
interface IChargersTable {
  // client: any;
  // stations: ChargePoint[];
  routes: any;
}

const ChargersTable = ({ routes }: IChargersTable) => {
  const history = useHistory();
  const [loading, setloading] = useState<boolean>(true);
  const [stationsDataList, setStationsDataList] = useState<ChargePoint[]>([]);
  const [data, setdata] = useState<any>([]);
  const [paginationData, setPaginationData] = useState<any>([]);
  const [pagination, setPagination] = useState<any>();
  const [reportModalStatus, setReportModalStatus] = useState<any>(false);
  const [reportQuota, setReportQuota] = useState<any>({ enforced: false });
  const [reportModalRadioValue, setReportModalRadioValue] = useState<any>(1);
  const [reportDoc, setReportDoc] = useState<any>({});
  const [isReportLoading, setIsReportLoading] = useState<any>(false);
  const [isExcelLoading, setIsExcelLoading] = useState<any>(false);
  const [fromDateInputValue, setFromDateInputValue] = useState<string>(START);
  const [toDateInputValue, setToDateInputValue] = useState<string>(END);
  const [inputArray, setInputArray] = useState<any>(['']);
  const [inputValue, setInputValue] = useState<any>('');
  const [stationGroupList, setStationGroupList] = useState<any>([]);
  const [tenantList, setTenantList] = useState<any>([]);
  const [chargeBoxGroupPk, setChargeBoxGroupPk] = useState<any>('');
  const [stations, setStations] = useState<any>([]);
  const [tenantPk, setTenantPk] = useState<any>('');
  const [online, setOnline] = useState<any>('');
  const [searchInput, setSearchInput] = useState('');
  const [costKwhInputValue, setCostKwhInputValue] = useState<any>('');
  const [incomeKwhInputValue, setIncomeKwhInputValue] = useState<any>('');
  const [document, setDocument] = useState<string>('');
  const [documentError, setDocumentError] = useState(false);
  const [active, setActive] = useState(true);
  const [activeInput, setActiveInput] = useState(false);
  const [checkChargePointLoading, setCheckChargePointLoading] = useState(false);
  const [hasDisableTransactionOption, setHasDisableTransactionOption] =
    useState(false);
  const [costError, setCostError] = useState(false);
  const [incomeError, setIncomeError] = useState(false);

  const blockNegativeChar = (e: any) =>
    ['-', 'e', 'E', '+', '.'].includes(e.key) && e.preventDefault();

  useEffect(() => {
    const hasCost = !!costKwhInputValue;
    const hasIncome = !!incomeKwhInputValue;

    if (hasCost && !hasIncome) {
      setIncomeError(true);
      setCostError(false);
    } else if (!hasCost && hasIncome) {
      setCostError(true);
      setIncomeError(false);
    } else {
      setCostError(false);
      setIncomeError(false);
    }
  }, [costKwhInputValue, incomeKwhInputValue]);

  const isValueInvalid =
    (!!costKwhInputValue && !incomeKwhInputValue) ||
    (!costKwhInputValue && !!incomeKwhInputValue);

  const childRef: any = useRef();

  const paginate = () => childRef?.current?.paginate();

  const RANGE_LIMIT_DAYS = 31;

  const [dates, setDates] = useState<any>([
    moment(START, 'DD/MM/YYYY'),
    moment(END, 'DD/MM/YYYY'),
  ]);
  const [value, setValue] = useState<any>([
    moment(START, 'DD/MM/YYYY'),
    moment(END, 'DD/MM/YYYY'),
  ]);

  useEffect(() => {
    const getStationsGroup = async () => {
      try {
        setloading(true);
        const chargePointGroups = await getChargePointGroups();
        setStationGroupList(chargePointGroups.list);
        const tenants = await getTenants();
        setTenantList(tenants.list);
      } catch (error) {
        setloading(false);
        console.error(error);
      }
    };

    getStationsGroup();
  }, []);

  //cpf/cnpj validation and formatting
  const formatDocument = (value: string) => formatCpfOrCnpj(value);

  const isValidDocument = (value: string) =>
    isCnpjInput(value)
      ? isValidCnpj(value)
      : stripCnpj(value).length === 11;

  const getStations = useCallback(
    async (
      page = 1,
      size = 10,
      active,
      chargeBoxGroupPk,
      tenantPk,
      searchInput,
      online,
    ) => {
      try {
        setloading(true);
        const apiOnlineParam = online === 'faulted' ? '' : online;
        const apiSize = online === 'faulted' ? 1000 : size;

        const chargePoints: any = await getChargePoints(
          online === 'faulted' ? 1 : page,
          apiSize,
          active,
          chargeBoxGroupPk,
          tenantPk,
          searchInput,
          apiOnlineParam,
        );

        let filteredStations = chargePoints?.chargePointList || [];

        if (online === 'faulted') {
          filteredStations = stationStatusFilter(filteredStations, 'faulted');
          const startIndex = (page - 1) * size;
          const endIndex = startIndex + size;
          const paginatedStations = filteredStations.slice(
            startIndex,
            endIndex,
          );

          setStationsDataList(paginatedStations);
        } else {
          setStationsDataList(filteredStations);
        }

        const currentPagination = {
          page,
          total:
            online === 'faulted'
              ? filteredStations.length
              : chargePoints?.count,
          move: async (page: number) => {
            await getStations(
              page,
              10,
              active,
              chargeBoxGroupPk,
              tenantPk,
              searchInput,
              online,
            );

            setPagination({ ...currentPagination, page });
          },
        };

        setPagination(currentPagination);

        setloading(false);
      } catch (error) {
        setloading(false);
        console.error(error);
      }
    },
    [],
  );

  useEffect(() => {
    (async function () {
      await getStations(
        1,
        10,
        active,
        chargeBoxGroupPk,
        tenantPk,
        searchInput,
        online,
      );
    })();
  }, [getStations, active, chargeBoxGroupPk, tenantPk, searchInput, online]);

  useEffect(() => {
    if (reportDoc.type === 'error') {
      if (reportDoc.status === 403) {
        modalErrorReport();
      } else {
        message.error('Não foi possível fazer o download do arquivo.');
      }
    }
  }, [reportDoc]);

  const quotaLabel = (remaining?: number) =>
    reportQuota.enforced && remaining !== undefined ? (
      <span
        style={{ color: '#8c8c8c', float: 'right', whiteSpace: 'nowrap' }}
      >
        {`${reportQuota.limit - remaining}/${reportQuota.limit}`}
      </span>
    ) : null;

  const reportTypeOption = (
    value: number,
    label: React.ReactNode,
    remaining?: number,
  ) => (
    <Radio style={radioStyle} value={value}>
      {label}
      {quotaLabel(remaining)}
    </Radio>
  );

  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  };

  useEffect(() => {
    if (!reportModalStatus) return;

    (async function () {
      setReportQuota(await getReportQuota());
    })();
  }, [reportModalStatus]);

  useEffect(() => {
    const fetchPermissions = async () => {
      const hasPermission = await getUserDashTransactionPermission();
      setHasDisableTransactionOption(hasPermission);
    };

    fetchPermissions();
  }, []);

  const HEADER = useMemo(
    () => [
      {
        text: T('Name'),
        sideIcon: <HeaderIcon />,
        action: (e: React.MouseEvent<HTMLDivElement>) =>
          normalOrder(
            'description',
            usersListFilter('', stationsDataList),
            (newList) => {
              setIconActive(e);
              closeAllCards();
              paginate();
              setdata(combiningObjects(newList, HEADER));
              setPaginationData(newList);
            },
            e,
          ),
        size: '25%',
        // the size is to be set in (flex-basis). So the total number of sizes of the header
        // must be equal to 100%
        dropdown: <></>,
      },
      {
        text: T('Account'),
        sideIcon: <HeaderIcon />,
        action: (e: React.MouseEvent<HTMLDivElement>) =>
          normalOrder(
            'tenantName',
            usersListFilter('', stationsDataList),
            (newList) => {
              setIconActive(e);
              closeAllCards();
              paginate();
              setdata(combiningObjects(newList, HEADER));
              setPaginationData(newList);
            },
            e,
          ),
        size: '14%',
        // the size is to be set in (flex-basis). So the total number of sizes of the header
        // must be equal to 100%
        dropdown: <></>,
      },
      {
        text: T('State'),
        sideIcon: <HeaderIcon />,
        action: (e: React.MouseEvent<HTMLDivElement>) =>
          orderByUF(
            usersListFilter('', stationsDataList),
            (newList) => {
              setIconActive(e);
              closeAllCards();
              paginate();
              setdata(combiningObjects(newList, HEADER));
              setPaginationData(newList);
            },
            e,
          ),
        size: '7%',
        dropdown: <></>,
      },
      {
        text: T('City'),
        sideIcon: <HeaderIcon />,
        action: (e: React.MouseEvent<HTMLDivElement>) =>
          orderByCity(
            usersListFilter('', stationsDataList),
            (newList) => {
              setIconActive(e);
              closeAllCards();
              paginate();
              setdata(combiningObjects(newList, HEADER));
              setPaginationData(newList);
            },
            e,
          ),
        size: '14%',
        dropdown: <></>,
      },
      {
        text: T('Recharges'),
        sideIcon: <HeaderIcon />,
        action: (e: React.MouseEvent<HTMLDivElement>) =>
          normalOrder(
            'usage',
            usersListFilter('', stationsDataList),
            (newList) => {
              setIconActive(e);
              closeAllCards();
              paginate();
              setdata(combiningObjects(newList, HEADER));
              setPaginationData(newList);
            },
            e,
          ),
        size: '10%',
        dropdown: <></>,
      },
      {
        text: 'kWh',
        sideIcon: <HeaderIcon />,
        action: (e: React.MouseEvent<HTMLDivElement>) =>
          normalOrder(
            'monthConsumption',
            usersListFilter('', stationsDataList),
            (newList) => {
              setIconActive(e);
              closeAllCards();
              paginate();
              setdata(combiningObjects(newList, HEADER));
              setPaginationData(newList);
            },
            e,
          ),
        size: '12%',
        dropdown: <></>,
      },
      {
        text: 'Heartbeat',
        sideIcon: <HeaderIcon />,
        action: (e: React.MouseEvent<HTMLDivElement>) =>
          orderByHearbeat(
            usersListFilter('', stationsDataList),
            (newList) => {
              setIconActive(e);
              closeAllCards();
              paginate();
              setdata(combiningObjects(newList, HEADER));
              setPaginationData(newList);
            },
            e,
          ),
        size: '15%',
        dropdown: <></>,
      },
      {
        text: T('Connectors'),
        sideIcon: <HeaderIcon2 />,

        size: '15%',
        dropdown: <></>,
      },
    ],
    [stationsDataList],
  );

  useEffect(() => {
    setdata(combiningObjects(stationsDataList, HEADER));
    setPaginationData(stationsDataList);
  }, [stationsDataList, HEADER]);

  useEffect(() => {
    paginate();
  }, [paginationData]);

  useEffect(() => {
    setFromDateInputValue(START);
    setToDateInputValue(END);
    setDates([moment(START, 'DD/MM/YYYY'), moment(END, 'DD/MM/YYYY')]),
      setValue([moment(START, 'DD/MM/YYYY'), moment(END, 'DD/MM/YYYY')]);
  }, [reportModalRadioValue]);

  const onOpenChange = (open: boolean) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const disabledDate = (current: any) => {
    if (!dates) return false;

    if (reportModalRadioValue === 1) {
      return current.valueOf() > Date.now();
    }

    const tooLate =
      dates?.[0] && current.diff(dates?.[0], 'days') >= RANGE_LIMIT_DAYS;
    const tooEarly =
      dates?.[1] && dates?.[1].diff(current, 'days') >= RANGE_LIMIT_DAYS;

    return !!tooEarly || !!tooLate || current.valueOf() > Date.now();
  };

  const modal = (
    <S.ReportsModal>
      <S.ReportModalTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <ChartIconSVG />
          {T('Generate Station Report')}
        </div>

        <S.CloseButton
          onClick={() => {
            setReportModalStatus(false);
            setCostKwhInputValue('');
            setIncomeKwhInputValue('');
          }}
        >
          ×
        </S.CloseButton>
      </S.ReportModalTitle>
      <S.ReportModalDivider />

      <S.ReportModalContent>
        {reportQuota.enforced && (
          <Alert
            message={TF(
              'Your plan is CVE lite. Each report type has a limit of {0} downloads per month. The counter is individual per type.',
              reportQuota.limit,
            )}
            showIcon
            style={{ borderRadius: 8, marginBottom: 16 }}
            type='warning'
          />
        )}

        <S.ReportModalSection>
          <S.ReportModalSectionTitle>{T('Period')}</S.ReportModalSectionTitle>
          <RangePickerCustom
            className='range_picker'
            format='DD/MM/YYYY'
            value={dates || value}
            disabledDate={disabledDate}
            onCalendarChange={(val) => setDates(val)}
            onChange={(val) => {
              setFromDateInputValue(
                val?.length && val[0]
                  ? moment(new Date(val[0])).format('DD/MM/YYYY')
                  : START,
              );
              setToDateInputValue(
                val?.length && val[1]
                  ? moment(new Date(val[1])).format('DD/MM/YYYY')
                  : END,
              );

              setValue(val);
            }}
            onOpenChange={onOpenChange}
            allowClear={false}
            separator=' ⟶ '
          />
        </S.ReportModalSection>

        <S.ReportModalDividerNormal />

        <S.ReportModalSection>
          <S.ReportModalSectionTitle>
            {T('Report Type')}
          </S.ReportModalSectionTitle>
          <Radio.Group
            style={{ width: '100%' }}
            value={reportModalRadioValue}
            onChange={(e) => setReportModalRadioValue(e.target.value)}
          >
            {reportTypeOption(1, T('Unified Report'), reportQuota.unified)}
            {reportTypeOption(3, T('Report by apartment'), reportQuota.byApartment)}
            {!hasDisableTransactionOption &&
              reportTypeOption(2, T('Individual Report'), reportQuota.individual)}
          </Radio.Group>
        </S.ReportModalSection>

        <S.ReportModalDividerNormal />

        <S.ReportModalSection>
          <S.ReportModalSectionTitle>
            {T('Value Configuration')}
          </S.ReportModalSectionTitle>
          <S.InputReportWrapper>
            <S.FormInputWrapper>
              <S.FormLabel>{T('Cost per kWh (R$)') + ':'}</S.FormLabel>
              <S.InputCostKwh
                name='costKwh'
                type='number'
                min={'0'}
                onKeyDown={blockNegativeChar}
                onChange={(e) => {
                  setCostKwhInputValue(e.target.value);
                  setCostError(false);
                }}
                value={costKwhInputValue}
                placeholder='0,00'
              />
              {costError && (
                <span style={{ color: 'red', fontSize: 12 }}>
                  {T('Provide a value for cost')}
                </span>
              )}
            </S.FormInputWrapper>
            <S.FormInputWrapper>
              <S.FormLabel>{T('Income per kWh (R$)') + ':'}</S.FormLabel>
              <S.InputIncomeKwh
                name='incomeKwh'
                type='number'
                min={'0'}
                onKeyDown={blockNegativeChar}
                onChange={(e) => {
                  setIncomeKwhInputValue(e.target.value);
                  setIncomeError(false);
                }}
                value={incomeKwhInputValue}
                placeholder='0,00'
              />
              <div style={{ minHeight: 20, lineHeight: '8px' }}>
                {incomeError && (
                  <span style={{ color: 'red', fontSize: 12 }}>
                    {T('Provide a value for income')}
                  </span>
                )}
              </div>
            </S.FormInputWrapper>
          </S.InputReportWrapper>
        </S.ReportModalSection>

        <S.ReportModalDividerSmall />

        <S.ReportModalSection>
          <S.ReportModalSectionTitle
            style={{ lineHeight: '10px', marginBottom: '12px' }}
          >
            {T('Client CPF/CNPJ')}
          </S.ReportModalSectionTitle>
          <S.InputReportWrapper>
            <S.FormInputWrapper>
              <S.InputDocument
                name='document'
                type='text'
                min={'0'}
                onChange={(e) => {
                  const formatted = formatDocument(e.target.value);
                  setDocument(formatted);

                  const isValid = isValidDocument(formatted);
                  setDocumentError(!isValid && formatted.length > 0);
                }}
                value={document}
                placeholder='000.000.000-00 / 00.000.000/0000-00'
              />
              <div style={{ minHeight: 12, lineHeight: '10px' }}>
                {documentError && (
                  <span style={{ color: 'red', fontSize: 12 }}>
                    {T('Provide a valid CPF/CNPJ')}
                  </span>
                )}
              </div>
            </S.FormInputWrapper>
          </S.InputReportWrapper>
        </S.ReportModalSection>

        <S.ReportModalButtonGroup>
          <Button
            onClick={() => {
              setReportModalStatus(false);
              setCostKwhInputValue('');
              setIncomeKwhInputValue('');
            }}
          >
            {T('Cancel')}
          </Button>
          {isReportLoading ? (
            <Spin indicator={antLoadingIcon} />
          ) : (
            <Button
              type='primary'
              disabled={isValueInvalid || documentError}
              onClick={async () => {
                setIsReportLoading(true);
                switch (reportModalRadioValue) {
                  case 1:
                    setReportDoc(
                      await createUnifiedReport({
                        from_date: moment(
                          fromDateInputValue,
                          'DD/MM/YYYY',
                        ).format('YYYY-MM-DD'),
                        to_date: moment(toDateInputValue, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD',
                        ),
                        logo: `https://storage.googleapis.com/mk-move-repository/white-label/${THEME}/images/dash-logo.png`,
                        cost_kwh: costKwhInputValue,
                        income_kwh: incomeKwhInputValue,
                        charge_box_group_pk: chargeBoxGroupPk,
                        tenant_pk: tenantPk,
                        search_input: searchInput,
                        active: active,
                        online: online === 'faulted' ? '' : online,
                        is_by_apartment: false,
                        document: document,
                      }),
                    );
                    break;
                  case 2:
                    setReportDoc(
                      await createSeparatedReport({
                        from_date: moment(
                          fromDateInputValue,
                          'DD/MM/YYYY',
                        ).format('YYYY-MM-DD'),
                        to_date: moment(toDateInputValue, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD',
                        ),
                        logo: `https://storage.googleapis.com/mk-move-repository/white-label/${THEME}/images/dash-logo.png`,
                        cost_kwh: costKwhInputValue,
                        income_kwh: incomeKwhInputValue,
                        charge_box_group_pk: chargeBoxGroupPk,
                        tenant_pk: tenantPk,
                        search_input: searchInput,
                        active: active,
                        online: online === 'faulted' ? '' : online,
                      }),
                    );
                    break;
                  case 3:
                    setReportDoc(
                      await createUnifiedReport({
                        from_date: moment(
                          fromDateInputValue,
                          'DD/MM/YYYY',
                        ).format('YYYY-MM-DD'),
                        to_date: moment(toDateInputValue, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD',
                        ),
                        logo: `https://storage.googleapis.com/mk-move-repository/white-label/${THEME}/images/dash-logo.png`,
                        cost_kwh: costKwhInputValue,
                        income_kwh: incomeKwhInputValue,
                        charge_box_group_pk: chargeBoxGroupPk,
                        tenant_pk: tenantPk,
                        search_input: searchInput,
                        active: active,
                        online: online === 'faulted' ? '' : online,
                        is_by_apartment: true,
                        document: document,
                      }),
                    );
                    break;
                }
                setIsReportLoading(false);
                setReportModalStatus(false);
              }}
            >
              {T('Generate Report')}
            </Button>
          )}
        </S.ReportModalButtonGroup>
      </S.ReportModalContent>
    </S.ReportsModal>
  );

  const handleDownloadExcel = async () => {
    setIsExcelLoading(true);

    const xlsxChargerReport = await createXlsxChargerReport(
      active,
      chargeBoxGroupPk,
      tenantPk,
      searchInput,
      online === 'faulted' ? '' : online,
    );

    if (xlsxChargerReport.type === 'error') {
      if (xlsxChargerReport.status === 403) {
        modalErrorReport();
      } else {
        message.error('Não foi possível fazer o download do arquivo .xlxs.');
      }
    }
    setIsExcelLoading(false);
  };

  // event.target.value.replace(inputArray[inputArray.length -1], ''
  const handleKeyUp = (event: {
    charCode: number;
    target: { value: any };
  }): any => {
    if (event.charCode === 13) {
      const inputValue = event.target.value;
      let inputDuplicated = 0;

      inputArray.map((input: any) => {
        if (input === inputValue) {
          inputDuplicated++;
        }
      });

      if (inputDuplicated === 0) setInputArray([...inputArray, inputValue]);

      // setinputArray(inputArray)
      // filterStations(inputArray)
      setInputValue('');
    }
  };

  const onCreateStation = async () => {
    setCheckChargePointLoading(true);
    const response: any = await checkChargePoint();

    if (response.status === 403) {
      Modal.error({
        title: 'Limite de estações atingido!',
        content: (
          <div style={{ fontWeight: 300 }}>
            Caso deseje adicionar mais estações, será necessário fazer upgrade
            para a versão{' '}
            <strong style={{ fontWeight: 700 }}>{getProName()}</strong> ou
            excluir alguma estação.
          </div>
        ),
      });
    } else {
      history.push('/stations/create');
    }
    setCheckChargePointLoading(false);
  };

  return (
    <S.Div>
      <S.Title>
        <ChargerIcon
          className='wrapper-icon'
          fill={COLORS.black}
          height={20}
          width={20}
        />
        {T('Chargeboxes')}
      </S.Title>

      <S.Toolsbar>
        <Input.Search
          placeholder={T('Search by station name, state, city, or ID') + '.'}
          onSearch={(value) => setSearchInput(value)}
        />
        <S.FormInputWrapper style={{ display: 'flex' }}>
          <S.FormLabel>{T('Disabled Stations')}:</S.FormLabel>
          <S.SwitchWrapper>
            <Switch
              checked={activeInput}
              onChange={(checked) => {
                setActiveInput(checked);
                setActive(!checked);
              }}
            />
          </S.SwitchWrapper>
        </S.FormInputWrapper>

        <Select
          value={chargeBoxGroupPk}
          options={parserStationGroupsForSelect(stationGroupList)}
          action={(value: Number) => setChargeBoxGroupPk(value)}
          ordered
        />

        <Select
          value={tenantPk}
          options={parserTenantsForSelect(tenantList)}
          action={(value: Number) => setTenantPk(value)}
          ordered
        />

        <Select
          value={online}
          options={parserStatusForSelect(statusFilterOptions)}
          action={(value: Number) => setOnline(value)}
        />

        <S.Button
          type='default'
          className='action_button'
          onClick={() => setReportModalStatus(!reportModalStatus)}
        >
          {T('Report')}
        </S.Button>

        {isExcelLoading ? (
          <Spin style={{ marginLeft: 24 }} indicator={antLoadingIcon} />
        ) : (
          <S.Button
            type='default'
            className='action_button'
            onClick={() => handleDownloadExcel()}
          >
            {T('Download Excel')}
          </S.Button>
        )}

        {routes && routes.find(({ path }) => path === '/stations/create') ? (
          <S.Button
            disabled={checkChargePointLoading}
            onClick={onCreateStation}
            type='primary'
            className='action_button'
          >
            {T('New Station')}
          </S.Button>
        ) : null}
      </S.Toolsbar>

      {loading ? (
        <ListSkeleton style={{ paddingTop: 20 }} />
      ) : !loading && !data?.cardsList?.length ? (
        <EmptySearch />
      ) : (
        <CardListConstructor
          childRef={childRef}
          data={data}
          InnerComponent={StationCardInnerContent}
          pureData={stationsListTagFilter(inputArray, paginationData)}
          paginationCallback={() => {}}
          pagination={pagination}
        />
      )}

      {reportModalStatus && (
        <>
          <S.ModalOverlay onClick={() => setReportModalStatus(false)} />
          {modal}
        </>
      )}
    </S.Div>
  );
};

const mapStateToProps = (state: { user: { routes: any } }) => {
  return {
    routes: state.user.routes,
  };
};

export default connect(mapStateToProps)(ChargersTable);
